window.RRFeedingCalc = (function () {
  var PUPPY_PERCENT = 0.07;

  // Body condition moves the adult daily amount by one percentage point of
  // body weight either way, matching the ranges Sophie works from: for a
  // 20kg adult, underweight is 3 to 4%, ideal 2 to 3% and overweight 1 to 2%.
  // Applied to the activity level, so Standard (2.5%) becomes 3.5% when
  // underweight and 1.5% when overweight.
  var CONDITION_SHIFT = { underweight: 0.01, ideal: 0, overweight: -0.01 };
  var MIN_PERCENT = 0.01;

  function parsePackGrams(sizeStr) {
    if (!sizeStr) return null;
    var match = sizeStr.match(/^(\d+(?:\.\d+)?)\s*(kg|g)$/i);
    if (!match) return null;
    var value = parseFloat(match[1]);
    var unit = match[2].toLowerCase();
    return unit === 'kg' ? value * 1000 : value;
  }

  function trackEvent(name, data) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish(name, data || {});
      } catch (e) {
        /* analytics is best-effort; never let it break the calculator */
      }
    }
  }

  // Records where an item came from as a cart attribute, which carries onto
  // the order (admin only, never shown to customers). Best effort.
  function tagOrderSource(source, variantIds) {
    try {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var log = cart.attributes && cart.attributes.rr_upsell_log ? String(cart.attributes.rr_upsell_log).split(';') : [];
          variantIds.forEach(function (id) {
            var entry = source + ':' + id;
            if (log.indexOf(entry) === -1) log.push(entry);
          });
          while (log.join(';').length > 240) log.shift();
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { rr_upsell_log: log.join(';') } })
          });
        })
        .catch(function () { /* never let tagging affect the basket */ });
    } catch (e) { /* ignore */ }
  }

  // The 1 / 2 / 4 week buttons on the product-page calculator add to the
  // basket from inline code in snippets/feeding-calculator.liquid. Rather than
  // edit that, remember which pack a duration click was for and tag it when the
  // add succeeds (the page fires cart:refresh on success, and only then).
  var pendingDurationAdd = null;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fc-duration]') : null;
    if (!btn) return;
    var calcRoot = btn.closest('[data-feeding-calculator]');
    if (!calcRoot) return;
    pendingDurationAdd = { id: calcRoot.getAttribute('data-variant-id'), at: Date.now() };
  }, true);
  document.addEventListener('cart:refresh', function () {
    if (!pendingDurationAdd) return;
    var pending = pendingDurationAdd;
    pendingDurationAdd = null;
    if (Date.now() - pending.at < 6000 && pending.id) tagOrderSource('calculator', [pending.id]);
  });

  function formatCoverage(days) {
    var rounded = Math.round(days);
    if (rounded <= 0) return null;
    if (rounded < 7) {
      return rounded + (rounded === 1 ? ' day' : ' days');
    }
    var weeks = Math.floor(rounded / 7);
    var remDays = rounded % 7;
    var text = weeks + (weeks === 1 ? ' week' : ' weeks');
    if (remDays > 0) text += ' ' + remDays + (remDays === 1 ? ' day' : ' days');
    return text;
  }

  // Grams as a readable amount: 1750 -> 1.8kg, 600 -> 600g.
  function formatGrams(grams) {
    var n = Math.round(grams);
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'kg';
    return n + 'g';
  }

  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '¤{{amount}}';
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var precision = placeholder.indexOf('no_decimals') === -1 ? 2 : 0;
    var useComma = placeholder.indexOf('with_comma_separator') !== -1;
    var thousands = useComma ? '.' : ',';
    var decimalSep = useComma ? ',' : '.';
    var amount = (cents / 100).toFixed(precision);
    var parts = amount.split('.');
    var wholePart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var value = parts[1] ? wholePart + decimalSep + parts[1] : wholePart;
    return match ? formatString.replace(placeholderRegex, value) : formatString + value;
  }

  function shuffle(array) {
    var result = array.slice();
    for (var i = result.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = result[i];
      result[i] = result[j];
      result[j] = tmp;
    }
    return result;
  }

  function mergeObjects(a, b) {
    var out = {};
    var k;
    for (k in a) {
      if (Object.prototype.hasOwnProperty.call(a, k)) out[k] = a[k];
    }
    for (k in b) {
      if (Object.prototype.hasOwnProperty.call(b, k)) out[k] = b[k];
    }
    return out;
  }

  // Styles for the mix coverage notice and the top up suggestions. Added once
  // from here so they work on every surface without touching the stylesheet.
  var statusStylesAdded = false;
  function ensureStatusStyles() {
    if (statusStylesAdded) return;
    statusStylesAdded = true;
    var style = document.createElement('style');
    style.textContent =
      '.feeding-calculator__mix-status{margin:10px 0 0;padding:10px 12px;border-radius:8px;font-size:14px;line-height:1.45;border:1px solid transparent}' +
      '.feeding-calculator__mix-status[hidden]{display:none}' +
      '.feeding-calculator__mix-status--ok{background:#e9eee5;color:#3c4a35;border-color:#cfdac7}' +
      '.feeding-calculator__mix-status--warn{background:#fbeedd;color:#6f4210;border-color:#efcf9f}' +
      '.feeding-calculator__mix-alts{margin:8px 0 0;padding:10px 12px;border:1px dashed #cdbfae;border-radius:8px;background:#fff}' +
      '.feeding-calculator__mix-alts[hidden]{display:none}' +
      '.feeding-calculator__mix-alts-title{margin:0 0 6px;font-size:13px;font-weight:700;color:#3c4a35}' +
      '.feeding-calculator__mix-alt{display:flex;align-items:center;gap:10px;padding:8px 0;border-top:1px solid #eee3d3;font-size:13px}' +
      '.feeding-calculator__mix-alts-title + .feeding-calculator__mix-alt{border-top:0}' +
      '.feeding-calculator__mix-alt-info{flex:1;min-width:0}' +
      '.feeding-calculator__mix-alt-name{display:block;font-weight:600;line-height:1.3}' +
      '.feeding-calculator__mix-alt-sub{display:block;color:#6b6259;line-height:1.3}' +
      '.feeding-calculator__mix-alt-btn{flex:0 0 auto;border:1px solid #53664a;background:#fff;color:#53664a;border-radius:6px;padding:7px 12px;font-weight:700;font-size:13px;cursor:pointer;line-height:1.2}' +
      '.feeding-calculator__mix-alt-btn:hover{background:#53664a;color:#fff}' +
      '.feeding-calculator__pill-hint{display:block;margin-top:6px;font-size:12px;line-height:1.4;color:#6b6259;max-width:340px}';
    document.head.appendChild(style);
  }

  // Works out how many packs of each product to use so the total grams land
  // as close to the target as the pack sizes allow, without ever falling
  // short unless stock runs out. Each product is given a fair share in GRAMS
  // (not in packs), the product furthest below its share gets the next pack,
  // and for the last pack the smallest pack that still covers what is left is
  // preferred, so mixed pack sizes do not overshoot. `list` items look like
  // { grams, cap, packs }; cap is the stock limit (Infinity if untracked).
  // Returns the total grams allocated.
  function allocatePacks(list, targetGrams) {
    var i;
    for (i = 0; i < list.length; i++) list[i].packs = 0;
    var share = targetGrams / list.length;
    var total = 0;

    function deficitOf(it) {
      return share - it.packs * it.grams;
    }

    while (total < targetGrams) {
      var remaining = targetGrams - total;
      var best = null;
      var bestDeficit = -Infinity;
      for (i = 0; i < list.length; i++) {
        var it = list[i];
        if (it.packs >= it.cap) continue;
        var deficit = deficitOf(it);
        if (deficit > bestDeficit) {
          bestDeficit = deficit;
          best = it;
        }
      }
      if (!best) break;

      if (best.grams > remaining) {
        var tighter = null;
        for (i = 0; i < list.length; i++) {
          var cand = list[i];
          if (cand.packs >= cand.cap || cand.grams < remaining) continue;
          if (!tighter || cand.grams < tighter.grams || (cand.grams === tighter.grams && deficitOf(cand) > deficitOf(tighter))) {
            tighter = cand;
          }
        }
        if (tighter) best = tighter;
      }

      best.packs += 1;
      total += best.grams;
    }

    var trimmed = true;
    while (trimmed) {
      trimmed = false;
      var victim = null;
      var victimOver = -Infinity;
      for (i = 0; i < list.length; i++) {
        var t = list[i];
        if (t.packs > 0 && total - t.grams >= targetGrams) {
          var over = t.packs * t.grams - share;
          if (over > victimOver) {
            victimOver = over;
            victim = t;
          }
        }
      }
      if (victim) {
        victim.packs -= 1;
        total -= victim.grams;
        trimmed = true;
      }
    }

    return total;
  }

  // Wires the weight / life-stage / activity / body condition pill inputs
  // shared by both the product-page calculator and the collection-page
  // calculator. Returns a dailyGrams() getter plus helpers for wiring change
  // handlers and resetting.
  function createInputController(root, opts) {
    opts = opts || {};
    var trackContext = opts.trackContext || {};

    var weightInput = root.querySelector('[data-fc-weight]');
    var lifeStageInputs = root.querySelectorAll('[data-fc-life-stage]');
    var activityInputs = root.querySelectorAll('[data-fc-activity]');

    // Body condition is added here, next to the activity level, so both
    // calculators get it from one place. Adults only, like activity level.
    (function addConditionGroup() {
      if (root.querySelector('[data-fc-condition]')) return;
      var firstActivity = root.querySelector('[data-fc-activity]');
      var activityGroup = firstActivity ? firstActivity.closest('[data-fc-adult-group]') : null;
      if (!activityGroup || !activityGroup.parentNode) return;
      ensureStatusStyles();
      var group = document.createElement('div');
      group.className = 'feeding-calculator__pill-group';
      group.setAttribute('data-fc-adult-group', '');
      group.innerHTML =
        '<span class="feeding-calculator__pill-group-label">Body condition</span>' +
        '<div class="feeding-calculator__pill-row">' +
        '<button type="button" class="feeding-calculator__pill" data-fc-condition="underweight" aria-pressed="false">Underweight</button>' +
        '<button type="button" class="feeding-calculator__pill" data-fc-condition="ideal" aria-pressed="true">Ideal weight</button>' +
        '<button type="button" class="feeding-calculator__pill" data-fc-condition="overweight" aria-pressed="false">Overweight</button>' +
        '</div>' +
        '<span class="feeding-calculator__pill-hint">Enter your dog’s current weight above. Underweight adds about 1% of body weight to the daily amount, and overweight takes 1% off.</span>';
      activityGroup.parentNode.insertBefore(group, activityGroup.nextSibling);
    })();

    var adultGroups = root.querySelectorAll('[data-fc-adult-group]');
    var conditionInputs = root.querySelectorAll('[data-fc-condition]');

    var inputTracked = false;

    function pressedValue(buttons, attr) {
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].getAttribute('aria-pressed') === 'true') {
          return parseFloat(buttons[i].getAttribute(attr));
        }
      }
      return null;
    }

    function currentLifeStage() {
      for (var i = 0; i < lifeStageInputs.length; i++) {
        if (lifeStageInputs[i].getAttribute('aria-pressed') === 'true') {
          return lifeStageInputs[i].getAttribute('data-fc-life-stage');
        }
      }
      return 'adult';
    }

    function currentCondition() {
      for (var i = 0; i < conditionInputs.length; i++) {
        if (conditionInputs[i].getAttribute('aria-pressed') === 'true') {
          return conditionInputs[i].getAttribute('data-fc-condition');
        }
      }
      return 'ideal';
    }

    function currentPercent() {
      if (currentLifeStage() === 'puppy') return PUPPY_PERCENT;
      var base = pressedValue(activityInputs, 'data-fc-activity');
      if (!base) return base;
      var shift = CONDITION_SHIFT[currentCondition()] || 0;
      return Math.max(MIN_PERCENT, base + shift);
    }

    function dailyGrams() {
      var weightKg = parseFloat(weightInput.value);
      var percent = currentPercent();
      if (!weightKg || weightKg <= 0 || !percent) return null;
      return weightKg * 1000 * percent;
    }

    function maybeTrackInputUsed() {
      if (inputTracked) return;
      var daily = dailyGrams();
      if (!daily) return;
      inputTracked = true;
      trackEvent('feeding_calculator_input_used', mergeObjects({
        weightKg: parseFloat(weightInput.value),
        lifeStage: currentLifeStage(),
        activity: currentPercent(),
        bodyCondition: currentLifeStage() === 'puppy' ? 'puppy' : currentCondition()
      }, trackContext));
    }

    function bindChangeHandlers(onChange) {
      weightInput.addEventListener('input', function () {
        maybeTrackInputUsed();
        onChange();
      });
      lifeStageInputs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          lifeStageInputs.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var isPuppy = currentLifeStage() === 'puppy';
          adultGroups.forEach(function (g) { g.hidden = isPuppy; });
          maybeTrackInputUsed();
          onChange();
        });
      });
      activityInputs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activityInputs.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          maybeTrackInputUsed();
          onChange();
        });
      });
      conditionInputs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          conditionInputs.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          maybeTrackInputUsed();
          onChange();
        });
      });
    }

    function reset() {
      weightInput.value = '';
      lifeStageInputs.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-fc-life-stage') === 'adult' ? 'true' : 'false');
      });
      activityInputs.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-fc-activity') === '0.025' ? 'true' : 'false');
      });
      conditionInputs.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-fc-condition') === 'ideal' ? 'true' : 'false');
      });
      adultGroups.forEach(function (g) { g.hidden = false; });
      inputTracked = false;
    }

    return {
      weightInput: weightInput,
      dailyGrams: dailyGrams,
      currentLifeStage: currentLifeStage,
      currentCondition: currentCondition,
      currentPercent: currentPercent,
      bindChangeHandlers: bindChangeHandlers,
      reset: reset
    };
  }

  // Wires the mix & match panel (duration pills, per-row steppers, add to
  // basket) shared by both surfaces. `anchorFirstRow` keeps the current
  // product pinned as row 1 on product pages; the collection build has no
  // anchor, so every row is shuffled equally.
  function createMixController(root, opts) {
    opts = opts || {};
    var getDailyGrams = opts.getDailyGrams;
    var trackContext = opts.trackContext || {};
    var onAdded = opts.onAdded || function () {};
    var anchorFirstRow = opts.anchorFirstRow !== false;
    var fillCount = opts.fillCount || 3;
    var defaultDurationDays = opts.defaultDurationDays || 7;

    var mixDurationBtns = root.querySelectorAll('[data-fc-mix-duration]');
    var mixTarget = root.querySelector('[data-fc-mix-target]');
    var mixRowsWrap = root.querySelector('.feeding-calculator__mix-rows');
    var mixTotal = root.querySelector('[data-fc-mix-total]');
    var mixAddBtn = root.querySelector('[data-fc-mix-add]');
    var mixMessage = root.querySelector('[data-fc-mix-message]');
    var mixDurationDays = defaultDurationDays;
    var durationChosen = false;

    // Rows are looked up live because a customer can opt in to a top up
    // suggestion, which adds a row after the page has loaded.
    function getRows() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-fc-mix-row]'));
    }

    function removeAddedAlts() {
      Array.prototype.slice.call(root.querySelectorAll('[data-fc-added-alt]')).forEach(function (r) {
        if (r.parentNode) r.parentNode.removeChild(r);
      });
    }

    // Top up candidates the page rendered: raw dog food, in stock, with a pack
    // size. They stay hidden unless a mix cannot be covered from stock.
    var altData = Array.prototype.slice.call(root.querySelectorAll('[data-fc-alt-row]')).map(function (el) {
      var tracked = el.getAttribute('data-stock-tracked') === 'true';
      var stock = parseInt(el.getAttribute('data-stock-qty'), 10) || 0;
      return {
        title: el.getAttribute('data-title') || '',
        image: el.getAttribute('data-image') || '',
        packSize: el.getAttribute('data-pack-size'),
        grams: parsePackGrams(el.getAttribute('data-pack-size')) || 0,
        variantId: el.getAttribute('data-variant-id'),
        tracked: tracked,
        stock: stock,
        cap: tracked ? stock : Infinity,
        priceCents: parseInt(el.getAttribute('data-unit-price-cents'), 10) || 0,
        cls: el.getAttribute('data-class') || ''
      };
    }).filter(function (a) { return a.grams > 0 && a.variantId; });

    // A coverage notice sits directly under the total: green when the mix
    // covers the chosen duration, amber when it does not. Below it, the
    // optional top up suggestions.
    var mixStatus = null;
    var mixAlts = null;
    if (mixTotal && mixTotal.parentNode) {
      ensureStatusStyles();
      mixStatus = document.createElement('p');
      mixStatus.className = 'feeding-calculator__mix-status';
      mixStatus.setAttribute('data-fc-mix-status', '');
      mixStatus.setAttribute('role', 'status');
      mixStatus.hidden = true;
      mixTotal.parentNode.insertBefore(mixStatus, mixTotal.nextSibling);

      mixAlts = document.createElement('div');
      mixAlts.className = 'feeding-calculator__mix-alts';
      mixAlts.setAttribute('data-fc-mix-alts', '');
      mixAlts.hidden = true;
      mixStatus.parentNode.insertBefore(mixAlts, mixStatus.nextSibling);
    }

    function rowInfo(row) {
      var grams = parsePackGrams(row.getAttribute('data-pack-size')) || 0;
      var tracked = row.getAttribute('data-stock-tracked') === 'true';
      var stock = parseInt(row.getAttribute('data-stock-qty'), 10) || 0;
      return { row: row, grams: grams, cap: tracked ? stock : Infinity, packs: 0 };
    }

    function totals() {
      var grams = 0;
      var cents = 0;
      var any = false;
      getRows().forEach(function (row) {
        var qty = parseInt(row.querySelector('[data-fc-mix-qty]').value, 10) || 0;
        if (qty > 0) any = true;
        grams += qty * (parsePackGrams(row.getAttribute('data-pack-size')) || 0);
        cents += qty * (parseInt(row.getAttribute('data-unit-price-cents'), 10) || 0);
      });
      return { grams: grams, cents: cents, any: any };
    }

    // The most grams the automatic build could put in the mix given current
    // stock. Only products of the same kind (complete or complementary) count,
    // because that is all the build will use on its own.
    function maxAvailableGrams() {
      var cls = buildClass();
      var sum = 0;
      var rows = getRows();
      for (var i = 0; i < rows.length; i++) {
        var info = rowInfo(rows[i]);
        if (!info.grams) continue;
        var rowClass = rows[i].getAttribute('data-class') || '';
        var isAnchor = anchorFirstRow && i === 0;
        if (cls && rowClass !== cls && !isAnchor && !rows[i].hasAttribute('data-fc-added-alt')) continue;
        if (info.cap === Infinity) return Infinity;
        sum += info.cap * info.grams;
      }
      return sum;
    }

    // Which kind of food the automatic build sticks to: on a product page, the
    // same kind as that product; on a collection page, complete food when any
    // is in stock. Blank means no preference. Complete and complementary are a
    // real labelling difference, so the build never crosses it on its own.
    function buildClass() {
      var rows = getRows();
      if (anchorFirstRow && rows.length) return rows[0].getAttribute('data-class') || '';
      for (var i = 0; i < rows.length; i++) {
        var info = rowInfo(rows[i]);
        if (info.grams > 0 && info.cap > 0 && rows[i].getAttribute('data-class') === 'complete') return 'complete';
      }
      return '';
    }

    // Complete or complementary: a top up must be the same kind of food as the
    // mix so it never changes what the dog is actually being fed.
    function currentClass() {
      var rows = getRows();
      if (anchorFirstRow && rows.length) return rows[0].getAttribute('data-class') || '';
      var found = '';
      rows.forEach(function (r) {
        var qty = parseInt(r.querySelector('[data-fc-mix-qty]').value, 10) || 0;
        var cls = r.getAttribute('data-class') || '';
        if (qty > 0 && cls) {
          if (!found) found = cls;
          else if (found !== cls) found = 'mixed';
        }
      });
      return found === 'mixed' ? '' : found;
    }

    // Describes how the current mix compares with the chosen duration, or
    // null when there is nothing worth saying yet.
    function statusFor(daily, totalGrams) {
      if (!durationChosen || !totalGrams) return null;
      var targetGrams = Math.round(daily * mixDurationDays);
      var label = formatCoverage(mixDurationDays);
      var targetLabel = label.replace(/s$/, '');
      var coverage = formatCoverage(totalGrams / daily) || 'less than a day';

      if (totalGrams >= targetGrams - daily) {
        return { level: 'ok', stockLimited: false, label: label, coverage: coverage, head: 'Covers your full ' + label + '.', text: '' };
      }

      var shortBy = formatGrams(targetGrams - totalGrams);
      if (maxAvailableGrams() < targetGrams - daily) {
        return {
          level: 'warn',
          stockLimited: true,
          label: label,
          coverage: coverage,
          head: 'We can’t cover the full ' + label + '.',
          text: 'There isn’t enough stock across these products. This mix covers about ' + coverage + ', which is ' + shortBy + ' short of your ' + targetLabel + ' target.'
        };
      }
      return {
        level: 'warn',
        stockLimited: false,
        label: label,
        coverage: coverage,
        head: 'This mix doesn’t cover the full ' + label + ' yet.',
        text: 'It covers about ' + coverage + ', so it is ' + shortBy + ' short. Add more to reach ' + label + '.'
      };
    }

    function renderStatus(status) {
      if (!mixStatus) return;
      if (!status) {
        mixStatus.hidden = true;
        return;
      }
      mixStatus.className = 'feeding-calculator__mix-status feeding-calculator__mix-status--' + status.level;
      mixStatus.innerHTML = '<strong>' + status.head + '</strong>' + (status.text ? ' ' + status.text : '');
      mixStatus.hidden = false;
    }

    // Opt in top ups: only shown when stock genuinely cannot cover the chosen
    // duration. Nothing is added until the customer taps Add.
    function renderAlts(status, daily, totalGrams) {
      if (!mixAlts) return;
      while (mixAlts.firstChild) mixAlts.removeChild(mixAlts.firstChild);
      if (!status || status.level !== 'warn' || !status.stockLimited || !altData.length) {
        mixAlts.hidden = true;
        return;
      }

      var gap = Math.round(daily * mixDurationDays) - totalGrams;
      var inMix = {};
      getRows().forEach(function (r) { inMix[r.getAttribute('data-variant-id')] = true; });
      var cls = currentClass();
      var seen = {};
      var picks = [];
      altData.forEach(function (a) {
        if (inMix[a.variantId] || seen[a.variantId] || a.cap <= 0) return;
        if (cls && a.cls && a.cls !== cls) return;
        seen[a.variantId] = true;
        picks.push(a);
      });
      picks = picks.slice(0, 3);
      if (!picks.length) {
        mixAlts.hidden = true;
        return;
      }

      var heading = document.createElement('p');
      heading.className = 'feeding-calculator__mix-alts-title';
      heading.textContent = 'Want to top up? These raw foods are in stock and pair well with your mix.';
      mixAlts.appendChild(heading);

      picks.forEach(function (a) {
        var packs = Math.max(1, Math.min(Math.ceil(gap / a.grams), a.cap));
        var addsDays = formatCoverage((packs * a.grams) / daily);
        var addsText = addsDays ? 'adds about ' + addsDays : 'adds ' + formatGrams(packs * a.grams);

        var item = document.createElement('div');
        item.className = 'feeding-calculator__mix-alt';

        var info = document.createElement('span');
        info.className = 'feeding-calculator__mix-alt-info';
        var name = document.createElement('span');
        name.className = 'feeding-calculator__mix-alt-name';
        name.textContent = a.title;
        var sub = document.createElement('span');
        sub.className = 'feeding-calculator__mix-alt-sub';
        sub.textContent = a.packSize + ' · ' + formatMoney(a.priceCents, opts.moneyFormat) + ' · ' + packs + (packs === 1 ? ' pack' : ' packs') + ' ' + addsText;
        info.appendChild(name);
        info.appendChild(sub);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'feeding-calculator__mix-alt-btn';
        btn.textContent = 'Add ' + packs;
        btn.addEventListener('click', function () {
          addAltRow(a, packs);
        });

        item.appendChild(info);
        item.appendChild(btn);
        mixAlts.appendChild(item);
      });

      mixAlts.hidden = false;
    }

    // Turns a chosen suggestion into a normal mix row so the customer can
    // change the quantity like any other and add the whole mix in one go.
    function addAltRow(a, packs) {
      var row = document.createElement('div');
      row.className = 'feeding-calculator__mix-row feeding-calculator__mix-row--selected';
      row.setAttribute('data-fc-mix-row', '');
      row.setAttribute('data-fc-added-alt', '');
      row.setAttribute('data-pack-size', a.packSize);
      row.setAttribute('data-variant-id', a.variantId);
      row.setAttribute('data-stock-qty', String(a.tracked ? a.stock : 0));
      row.setAttribute('data-stock-tracked', a.tracked ? 'true' : 'false');
      row.setAttribute('data-unit-price-cents', String(a.priceCents));
      row.setAttribute('data-class', a.cls);

      if (a.image) {
        var img = document.createElement('img');
        img.className = 'feeding-calculator__mix-thumb';
        img.width = 32;
        img.height = 32;
        img.alt = '';
        img.src = a.image;
        row.appendChild(img);
      }

      var info = document.createElement('span');
      info.className = 'feeding-calculator__mix-info';
      var title = document.createElement('span');
      title.className = 'feeding-calculator__mix-title';
      title.textContent = a.title;
      var size = document.createElement('span');
      size.className = 'feeding-calculator__mix-size';
      size.textContent = a.packSize + ' · ' + formatMoney(a.priceCents, opts.moneyFormat);
      info.appendChild(title);
      info.appendChild(size);
      row.appendChild(info);

      var stepper = document.createElement('div');
      stepper.className = 'feeding-calculator__mix-stepper';
      stepper.innerHTML = '<button type="button" class="feeding-calculator__mix-step" data-fc-mix-step="-1" aria-label="Decrease quantity">&minus;</button><input type="number" min="0" step="1" value="0" class="feeding-calculator__mix-qty" data-fc-mix-qty inputmode="numeric"><button type="button" class="feeding-calculator__mix-step" data-fc-mix-step="1" aria-label="Increase quantity">+</button>';
      stepper.querySelector('[data-fc-mix-qty]').setAttribute('aria-label', 'Quantity of ' + a.title);
      row.appendChild(stepper);

      if (mixRowsWrap) mixRowsWrap.appendChild(row);
      bindRow(row);
      row.querySelector('[data-fc-mix-qty]').value = packs;
      update();
    }

    function update() {
      var daily = getDailyGrams();
      if (!daily) {
        if (mixTarget) mixTarget.hidden = true;
        if (mixTotal) mixTotal.hidden = true;
        if (mixStatus) mixStatus.hidden = true;
        if (mixAlts) mixAlts.hidden = true;
        if (mixAddBtn) mixAddBtn.disabled = true;
        return;
      }

      var targetGrams = Math.round(daily * mixDurationDays);
      if (mixTarget) {
        mixTarget.textContent = 'Target for ' + formatCoverage(mixDurationDays) + ': about ' + formatGrams(targetGrams);
        mixTarget.hidden = false;
      }

      getRows().forEach(function (row) {
        var qty = parseInt(row.querySelector('[data-fc-mix-qty]').value, 10) || 0;
        row.classList.toggle('feeding-calculator__mix-row--selected', qty > 0);
      });

      var t = totals();

      if (mixTotal) {
        var coverage = formatCoverage(t.grams / daily);
        var totalText = t.grams + 'g';
        if (coverage) totalText += ' (about ' + coverage + ')';
        totalText += ' · ' + formatMoney(t.cents, opts.moneyFormat);
        mixTotal.textContent = totalText;
        mixTotal.hidden = false;
      }

      var status = statusFor(daily, t.grams);
      renderStatus(status);
      renderAlts(status, daily, t.grams);
      if (mixAddBtn) mixAddBtn.disabled = !t.any;
    }

    mixDurationBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mixDurationDays = parseInt(btn.getAttribute('data-fc-mix-duration'), 10);
        durationChosen = true;
        mixDurationBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });

        // A fresh build starts from the original products, not earlier top ups.
        removeAddedAlts();

        var daily = getDailyGrams();
        if (daily) {
          var targetGrams = Math.round(daily * mixDurationDays);
          var infos = getRows().map(rowInfo);
          var usable = function (it) { return it.grams > 0 && it.cap > 0; };
          var wantClass = buildClass();
          var sameKind = function (it) { return !wantClass || (it.row.getAttribute('data-class') || '') === wantClass; };

          // The current product (product page only) always leads, then a random
          // selection of the others of the same kind. Products with no stock are
          // never chosen.
          var ordered = [];
          if (anchorFirstRow && infos.length && usable(infos[0])) ordered.push(infos[0]);
          var others = shuffle(infos.slice(anchorFirstRow ? 1 : 0).filter(usable).filter(sameKind));
          ordered = ordered.concat(others);

          var count = Math.min(fillCount, ordered.length);
          var chosen = ordered.slice(0, count);
          if (chosen.length) {
            var built = allocatePacks(chosen, targetGrams);
            // Still short with the products picked so far: bring in more
            // in-stock products before giving up on the full duration.
            while (built < targetGrams && count < ordered.length) {
              count += 1;
              chosen = ordered.slice(0, count);
              built = allocatePacks(chosen, targetGrams);
            }
          }

          infos.forEach(function (it) {
            var qtyInput = it.row.querySelector('[data-fc-mix-qty]');
            qtyInput.value = chosen.indexOf(it) === -1 ? 0 : it.packs;
          });
        }

        update();
      });
    });

    function bindRow(row) {
      var qtyInput = row.querySelector('[data-fc-mix-qty]');
      var stepButtons = row.querySelectorAll('[data-fc-mix-step]');
      var rowStockTracked = row.getAttribute('data-stock-tracked') === 'true';
      var rowStockQty = parseInt(row.getAttribute('data-stock-qty'), 10) || 0;
      if (rowStockTracked) qtyInput.max = rowStockQty;

      function clampQty() {
        var val = parseInt(qtyInput.value, 10) || 0;
        if (val < 0) val = 0;
        if (rowStockTracked && val > rowStockQty) val = rowStockQty;
        qtyInput.value = val;
      }

      qtyInput.addEventListener('input', function () {
        clampQty();
        update();
      });

      stepButtons.forEach(function (stepBtn) {
        stepBtn.addEventListener('click', function () {
          var delta = parseInt(stepBtn.getAttribute('data-fc-mix-step'), 10) || 0;
          var val = (parseInt(qtyInput.value, 10) || 0) + delta;
          if (val < 0) val = 0;
          if (rowStockTracked && val > rowStockQty) val = rowStockQty;
          qtyInput.value = val;
          update();
        });
      });
    }

    getRows().forEach(bindRow);

    if (mixAddBtn) {
      mixAddBtn.addEventListener('click', function () {
        var items = [];
        getRows().forEach(function (row) {
          var qtyInput = row.querySelector('[data-fc-mix-qty]');
          var qty = parseInt(qtyInput.value, 10) || 0;
          if (qty > 0) {
            items.push({ id: row.getAttribute('data-variant-id'), quantity: qty });
          }
        });
        if (!items.length) return;

        // Work out, before the rows are cleared, whether this mix falls short
        // of the chosen duration so the confirmation can say so plainly.
        var addDaily = getDailyGrams();
        var addStatus = addDaily ? statusFor(addDaily, totals().grams) : null;

        mixAddBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Could not add to basket');
            return res.json();
          })
          .then(function () {
            if (mixMessage) {
              var note = addStatus && addStatus.level === 'warn'
                ? ' Please note it covers about ' + addStatus.coverage + ', not the full ' + addStatus.label + '.'
                : '';
              mixMessage.textContent = 'Added your mix to the basket.' + note;
              mixMessage.hidden = false;
            }
            tagOrderSource('calculator', items.map(function (it) { return it.id; }));
            trackEvent('feeding_calculator_mix_add_to_cart', mergeObjects({
              lineCount: items.length,
              totalQuantity: items.reduce(function (sum, item) { return sum + item.quantity; }, 0)
            }, trackContext));
            getRows().forEach(function (row) {
              row.querySelector('[data-fc-mix-qty]').value = 0;
            });
            removeAddedAlts();
            update();
            onAdded();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () {
            if (mixMessage) {
              mixMessage.textContent = 'Sorry, that could not be added. Please try again.';
              mixMessage.hidden = false;
            }
          })
          .finally(function () {
            mixAddBtn.disabled = false;
          });
      });
    }

    function reset() {
      mixDurationDays = defaultDurationDays;
      durationChosen = false;
      mixDurationBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      removeAddedAlts();
      getRows().forEach(function (row) {
        row.querySelector('[data-fc-mix-qty]').value = 0;
      });
      if (mixMessage) mixMessage.hidden = true;
      update();
    }

    return { update: update, reset: reset };
  }

  return {
    parsePackGrams: parsePackGrams,
    trackEvent: trackEvent,
    formatCoverage: formatCoverage,
    formatGrams: formatGrams,
    formatMoney: formatMoney,
    shuffle: shuffle,
    createInputController: createInputController,
    createMixController: createMixController
  };
})();
